import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const CCUsersContainer = styled.div`
  width: 100%; /* Ensure full width of the upload tab */
`;

export const StyledTextField = styled(TextField)`
  width: 100%; /* Full width for the input */
`;

export const DropdownMenu = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  /* background-color: ${({ theme }) => theme.palette.primary.dark}; */
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
`;